import {
  capitalizeFirstLetter,
  concatStringsWithMiddleDot,
} from '@autone/utils';

import { ProductInfo } from '../ProductInfo';

const ProductColorMaterial = ({
  colorDesc,
  materialDesc,
  className,
}: {
  colorDesc?: string | null | undefined;
  materialDesc?: string | null | undefined;
  className?: string;
}) => {
  const capitalizedColor = capitalizeFirstLetter(colorDesc);
  const capitalizedMaterial = capitalizeFirstLetter(materialDesc);
  const text = concatStringsWithMiddleDot([
    capitalizedColor,
    capitalizedMaterial,
  ]);
  return <ProductInfo.SubTitle className={className} value={text} />;
};

export default ProductColorMaterial;
